const pagesProfileAppIdRuleAndPolicyEn = {
  pageTitle: "{{name}} - Rule&Policy",
  common: {
    action: {
      edit: "Edit",
      cancel: "Cancel",
      save: "Save",
      savedCustomFilter: "Saved Custom Rule",
      add: "Add",
      newRule: "New Rule",
      noCustomRuleTitle: "Name not specified",
      noCustomRule: "no rule set",
      invalidCustomRule:
        "There are conditions that are not set correctly in the rule",
      successfulMessage:
        "🎉 Saved successfully! After a few moments, the rule will be reflected in the list of accounts",
    },
    tableOfContent: {
      title: "Assignment rules",
    },
    infoMessage: {
      description:
        "Rules are applied in order from the role with the strongest authority. Accounts assigned to higher roles are not eligible for assignment under the rules for lower roles.",
    },
    settingType: {
      ALL: "Assign to all",
      NO_ONE: "Assign to no one",
      CUSTOM: "Custom Rule",
      CUSTOM_NEST: "Custom Rule(Nested)",
    },
    settingTypeForTop: {
      ALL: "All",
      NO_ONE: "-",
      CUSTOM: "-",
      CUSTOM_NEST: "-",
    },
    workerType: {
      // TODO: common.workerType に統一したい
      EMPLOYEE: "Employee",
      BOARD_MEMBER: "Board",
      CONTRACTOR: "Contractor",
      COLLABORATOR: "Collaborator",
    },
    individual: {
      include: "Include",
      includeNone: "-",
      exclude: "Exclude",
      excludeNone: "-",
    },
  },
  components: {
    customRuleExpression: {
      addCondition: "Add condition",
      addConditionGroup: "Add condition group",
    },
    conditionCommandLine: {
      placeholder: "Search person attributes...",
      placeholderForInt: "Enter a number...",
      noResultsFound: "No results found",
    },
    commandLineUserGuidance: {
      title: "Add condition for person",
      select: "Select",
      addCondition: "Add condition",
    },
  },
};

export default pagesProfileAppIdRuleAndPolicyEn;
